<!-- Header -->
<h3 mat-dialog-title
    translate>
    Email Sent
</h3>
<mat-dialog-content>
    <div>
        <span>
            <span translate>An email has been sent to</span>
            {{emailAddress}}. 
            <span translate *ngIf="!enableSelfRegistrationCode && !displayAsPopupOnly">Please use the link in the email to proceed to the next step.</span>
        </span>
        <!-- <span *ngIf="!enableSelfRegistrationCode && !LoginSettings.V10 && emailAddress !=''" translate>An email with a link has been sent to {{registerNewFamily != undefined ? registerNewFamily.emailAddress : emailAddress}}.</span>
        <span *ngIf="!enableSelfRegistrationCode && !LoginSettings.V10 && emailAddress ==''" translate>An email with a link has been sent.</span><br /><br />
        <span *ngIf="!enableSelfRegistrationCode && !LoginSettings.V10" translate>Please use the link in the email to proceed to the next step.</span> -->
    </div>
    <div *ngIf="enableSelfRegistrationCode">
        <div translate>Please enter the code provided in that email. </div>
        <tyl-form-field style="width:100px; padding-top: 10px; margin-bottom: 1px;" label="Code">
            <input matInput id="inputVeificationCode" name="inputVeificationCode" [maxlength]="6"
                [(ngModel)]="verifyCode" #code />
        </tyl-form-field>
    </div>
</mat-dialog-content>
<mat-dialog-actions style="position: sticky">
    <div class="footerRight">
        <tyl-button *ngIf="enableSelfRegistrationCode" image="next arrow yellow.png" label="Submit" (clickEvent)="modalInstanceNextClick()"></tyl-button>
        <tyl-button image="Cancel.png" label="Close" (clickEvent)="modalInstanceCloseClick()"></tyl-button>
    </div>
</mat-dialog-actions>
